import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import RegionalPage from '@/pages/regional/page';
import TestimonialsPage from '@/pages/testimonials/page';
import FaqPage from '@/pages/faq/page';
import CompanyPage from '@/pages/company/page';
import ListingsPage from '@/pages/listings/page';
import ContactPage from '@/pages/contact/page';
import PrivacyPage from '@/pages/privacy/page';
import AiSateiPage from '@/pages/ai-satei/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/regional', element: <RegionalPage /> },
  { path: '/testimonials', element: <TestimonialsPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/company', element: <CompanyPage /> },
  { path: '/listings', element: <ListingsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/ai-satei', element: <AiSateiPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
